import React from "react";
import { Routes, Route } from "react-router-dom";

import NCPLayout from "./NCPLayout";
import Home from "../Pages/Home/Home";
import AboutUs from "../Pages/AboutUs/AboutUs";
import Teams from "../Pages/Teams";
import SEngagement from "../Pages/Gallary/StudentEngagement";
import Partnerships from "../Pages/Gallary/Partnerships";
import Publications from "../Pages/Gallary/Publications";

import PScholarships from "../Pages/Programs/Scholarships";
import ContactUs from "../Pages/ContactUs";
const NCPRoutes = () => {
    return (<>
   <Routes>
        {/* Below is for home pages routes */}
        <Route path="/" element={<NCPLayout />}>
          <Route index element={<Home />} />
           <Route path="/AboutUs" element={<AboutUs />} />
           <Route path="/Teams" element={<Teams />} />
          <Route path="/Student Engagement" element={<SEngagement />} />
          <Route path="/Partnerships" element={<Partnerships />} />
          <Route path="/Publications" element={<Publications />} />
          <Route path="/Programs/Scholarships" element={<PScholarships />} />
          <Route path="/Programs/Skills" element={<PScholarships />} />
          <Route path="/Programs/Seva" element={<PScholarships />} />
          <Route path="/Programs/MMPrograms" element={<PScholarships />} />
          <Route path="/Contact Us" element={<ContactUs />} />
          {/* <Route path="/Login" element={<Login />} />  */}
        </Route>
        </Routes>
    </>)
}

export default NCPRoutes;